import { render } from "./CyanPageWrapper.vue?vue&type=template&id=56fb2ff4&scoped=true"
import script from "./CyanPageWrapper.vue?vue&type=script&lang=ts"
export * from "./CyanPageWrapper.vue?vue&type=script&lang=ts"

import "./CyanPageWrapper.vue?vue&type=style&index=0&id=56fb2ff4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-56fb2ff4"

export default script